import { Link } from "react-router-dom";
import { animeList } from "@/mocks/animeData";

interface AnimeCardProps {
  anime: (typeof animeList)[0];
  variant?: "default" | "horizontal";
}

export default function AnimeCard({ anime, variant = "default" }: AnimeCardProps) {
  if (variant === "horizontal") {
    return (
      <Link
        to="/category/all"
        className="flex gap-4 bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-colors group cursor-pointer"
      >
        <div className="w-28 md:w-32 flex-shrink-0 aspect-[3/4] overflow-hidden rounded-xl">
          <img
            src={anime.coverImage}
            alt={anime.title}
            title={anime.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        <div className="flex flex-col justify-center py-2 pr-4 min-w-0">
          <h3 className="text-sm font-semibold text-foreground-900 leading-tight mb-1 truncate">
            {anime.title}
          </h3>
          <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
            <span className="px-1.5 py-0.5 bg-primary-50 text-primary-600 rounded text-[10px] font-medium">
              {anime.category}
            </span>
            <span>{anime.episode}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-[10px]"></i>
              {anime.rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-[10px]"></i>
              {anime.views}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to="/category/all"
      className="block group cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-secondary-100 mb-3">
        <img
          src={anime.coverImage}
          alt={anime.title}
          title={anime.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-2.5 left-2.5">
          <span className="px-2 py-0.5 bg-primary-500 text-white text-[10px] font-semibold rounded-md whitespace-nowrap">
            {anime.episode}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
          <span className="text-white text-sm font-medium bg-white/20 backdrop-blur-sm px-4 py-1.5 rounded-full whitespace-nowrap">
            <i className="ri-play-fill mr-1"></i>立即播放
          </span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 leading-tight mb-1 truncate">
        {anime.title}
      </h3>
      <div className="flex items-center justify-between text-xs text-foreground-500">
        <span>{anime.category}</span>
        <span className="flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          {anime.rating}
        </span>
      </div>
    </Link>
  );
}